export default __webpack_public_path__ + "media/images/right-arrow-be87bc77068c9c47355503577e5bd94b.svg";